import _ChevronDownIcon from "@adsk/alloy-react-icon/es/lib/ChevronDownIcon";
const _excluded = ["style", "children", "disabled", "data-testid"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useState } from 'react';
import computeScrollIntoView from 'compute-scroll-into-view';
import Button from '@adsk/alloy-react-button';
import { DropdownMenu, useDropdown, PLACEMENTS } from '@adsk/alloy-react-dropdown';
import theme from '@adsk/alloy-react-theme';
const YearMonthDropdown = _ref => {
  let {
      style,
      children,
      disabled,
      'data-testid': dataTestId
    } = _ref,
    useDropdownProps = _objectWithoutProperties(_ref, _excluded);
  const [isInitialScroll, setIsInitialScroll] = useState(true);

  /**
   * This is the default downshift behaviour, modified on initial scroll
   * https://github.com/downshift-js/downshift/blob/bcc793a194a7c30f84b4514b8541a6b7ee3d991f/src/utils.js#L25-L39
   */
  const centerOnInitialScroll = useCallback((node, menuNode) => {
    const actions = computeScrollIntoView(node, {
      boundary: menuNode,
      block: isInitialScroll ? 'center' : 'nearest',
      scrollMode: 'if-needed'
    });
    actions.forEach(_ref2 => {
      let {
        el,
        top,
        left
      } = _ref2;
      el.scrollTop = top;
      el.scrollLeft = left;
    });
    setIsInitialScroll(false);
  }, [isInitialScroll]);
  const {
    controlProps,
    menuProps
  } = useDropdown(_objectSpread({
    placement: PLACEMENTS.BOTTOM_START,
    scrollIntoView: centerOnInitialScroll
  }, useDropdownProps));
  const {
    ref,
    isOpen,
    getToggleButtonProps
  } = controlProps;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement(Button, _extends({
    "data-testid": dataTestId,
    style: [{
      padding: "0 ".concat(theme.spacing.XS, "px"),
      border: 'none',
      width: 'auto',
      color: theme.tokens.colors.text.primary.value,
      '&:disabled': {
        color: theme.tokens.colors.text.inactive.value
      }
    }, style],
    variant: Button.VARIANTS.TERTIARY
  }, getToggleButtonProps(), {
    selected: isOpen,
    disabled: disabled
  }), children, /*#__PURE__*/React.createElement(_ChevronDownIcon, {
    style: {
      marginLeft: theme.spacing.XS,
      width: 18,
      height: 18
    }
  })), /*#__PURE__*/React.createElement(DropdownMenu, _extends({
    style: {
      width: 130,
      maxHeight: 272,
      overflowY: 'auto'
    },
    renderFooter: () => null // Cannot clear this dropdown, so no footer needed
  }, menuProps)));
};
YearMonthDropdown.displayName = 'YearMonthDropdown';
export default YearMonthDropdown;
//# sourceMappingURL=YearMonthDropdown.js.map